<div [class]="containerClasses(level())" class="mb-4">
  <div [class]="background(level())" class="p-4 font-semibold text-xl rounded-t-sm flex justify-center items-center gap-1">
    <div class="flex">
      @for (star of stars(level()); track $index) {
        <app-icons icon="star" svgClass=""/>
      }
    </div>
    {{ level() | uppercase }}
  </div>
  <div class="text-center">
    <div class="p-4 inline-block">
      <app-item-image [item]="item()" width="100" height="100" (click)="showDetails.set(true)" class="cursor-pointer"/>
    </div>

    <p><span class="font-bold">{{ price() | currency }}</span> ea.</p>
    <p class="font-semibold">{{ item().brand }}</p>
    <p [title]="item().model" class="line-clamp-1">{{ item().model }}</p>
    <p [title]="item().item_number" class="line-clamp-1">{{ item().item_number }}</p>
    <p>{{ item().size }} {{ getFeatureString(item()) }}</p>

    <div class="px-4 space-y-4">
      <app-accordion label="Details" [(isOpen)]="compareComponent.detailsOpen">
        <header class="text-sm">Details</header>

        <div class="text-sm space-y-4">
          <div class="font-semibold flex justify-between">
            <span>Subtotal</span>
            <span>{{ subtotal() | currency }}</span>
          </div>

          @if (addons().length) {
            <app-hr></app-hr>

            @for (addon of addons(); track $index) {
              <div class="flex justify-between h-5 gap-1" [class.line-through]="addon && !isAddonSelected(addon.item_id)" [class.opacity-40]="addon && !isAddonSelected(addon.item_id)">
                @if (addon) {
                  <span class="truncate min-w-0" [title]="addon.description">{{ addon.description }}</span>

                  @if (addon.price_each) {
                    <div class="flex gap-1 items-center shrink-0"><span class="text-xs text-body">(per tire)</span> <span class="font-semibold text-sm">{{ addon.price_each | currency }}</span></div>
                  } @else {
                    <span class="shrink-0">-</span>
                  }
                }
              </div>
            }
          }

          @if (fees().length) {
            <app-hr></app-hr>

            @for (fee of fees(); track $index) {
              <div class="flex justify-between h-5 gap-1">
                @if (fee) {
                  <span class="truncate min-w-0" [title]="fee.description">{{ fee.description }}</span>
                  <span class="font-semibold shrink-0">{{ fee.total ? (fee.total - fee.tax | currency) : '-' }}</span>
                }
              </div>
            }
          }

          <div class="flex justify-between">
            <span>Sales Tax</span>
            <span class="font-semibold">{{ tax() | currency }}</span>
          </div>

          <app-hr></app-hr>
        </div>
      </app-accordion>

      <div class="flex justify-between text-md text-brand font-semibold">
        <span>Total</span>

        @if (loading()) {
          <app-spinner></app-spinner>
        } @else {
          <span>{{ outTheDoorPricing() | currency }}</span>
        }
      </div>

      <div class="mb-2">
        <app-button variant="secondary" size="small" (click)="selectItem()" [disabled]="isSelected()">
          @if (isSelected()) {
            Selected
          } @else {
            Select <app-icons icon="arrow-right"></app-icons>
          }
        </app-button>
      </div>
    </div>
  </div>
</div>

<div>
  <app-text-area [value]="item().customer_notes ?? ''" (valueChange)="setNotes($event)" [rows]="3" label="Notes"/>
</div>

<app-results-item-details-modal [item]="item()" [(isOpen)]="showDetails"/>
